export { ImageDetailedView } from './ImageDetailedView';
export { type ImageDetailedViewProps } from './hooks';
